import React from 'react'
import { NavbarComponent, FooterComponent } from '../../SharedComponents'
import TreatmentProcessSection from './TreatmentProcessSection'
import HealthAndSafetySection from './Health&SafetySection'
import SustainabilitySection from './SustainabilitySection'
import FacilitySection from './FacilitySection'
import ContactSection from './ContactSection'
import AboutUsSection from './AboutUsSection'
import ServiceSection from './ServiceSection'
import HeroSection from './HeroSection'
import Section3 from './Section3'
import './LandingPage.css'

export default function LandingPage() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
    return (
        <div>
            <NavbarComponent />
            <HeroSection />
            <AboutUsSection />
            <Section3 />
            <HealthAndSafetySection />
            <SustainabilitySection />
            <FacilitySection />
            <TreatmentProcessSection />
            <ServiceSection />
            <ContactSection />
            <FooterComponent />
        </div>
    )
}
